import clsx from 'clsx';

type HeadlineProps = {
  level: 1 | 2 | 3 | 4 | 5 | 6;
  children: string;
  center?: boolean;
  className?: string;
};

export function Headline({ level, children, center = false, className }: HeadlineProps): JSX.Element {
  if (level === 1) {
    return (
      <h1 className={clsx('mt-5', className)} style={center ? { textAlign: 'center' } : {}}>
        {children}
      </h1>
    );
  }
  if (level === 2) {
    return (
      <h2 className={clsx('my-5', className)} style={center ? { textAlign: 'center' } : {}}>
        {children}
      </h2>
    );
  }
  if (level === 3) {
    return (
      <h3 className={clsx('mb-12 mt-8', className)} style={center ? { textAlign: 'center' } : {}}>
        {children}
      </h3>
    );
  }
  if (level === 4) {
    return (
      <h4 className={clsx('mt-4.5', className)} style={center ? { textAlign: 'center' } : {}}>
        {children}
      </h4>
    );
  }
  if (level === 5) {
    return (
      <h4 className={className} style={center ? { textAlign: 'center' } : {}}>
        {children}
      </h4>
    );
  }
  if (level === 6) {
    return (
      <h4 className={className} style={center ? { textAlign: 'center' } : {}}>
        {children}
      </h4>
    );
  }

  return <></>;
}
